const GB_LOCALE = "en-GB" as Intl.LocalesArgument

const intlDateTimeFormat = (date: Date, format: Intl.DateTimeFormatOptions): string => {
  // We expect `en-*` locales to return "Sep" as a short month but they may also return "Sept". See:
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format#return_value
  return new Intl.DateTimeFormat(GB_LOCALE, format).format(date).replace(/\bSept\b/, "Sep")
}

const formatDMMM = (date: Date): string => {
  return intlDateTimeFormat(date, {
    day: "numeric",
    month: "short"
  })
}

const formatDDMMYYYY = (date: Date): string => {
  return intlDateTimeFormat(date, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  })
}

const formatEEEDMMMYYYY = (date: Date): string => {
  return intlDateTimeFormat(date, {
    day: "numeric",
    month: "short",
    weekday: "short",
    year: "numeric"
  })
}

const formatISO = (date: Date): string => date.toISOString().split("T").at(0)!

const formatMMMM = (date: Date): string => {
  return intlDateTimeFormat(date, {
    month: "long"
  })
}

export { formatDMMM, formatDDMMYYYY, formatEEEDMMMYYYY, formatISO, formatMMMM }
